var _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 26,
    viewBox: "0 0 57 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 53.151,
    y1: 5.81378,
    x2: 25.1519,
    y2: 19.8133,
    stroke: "white",
    strokeWidth: 13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -6.5,
    x2: 31.304,
    y2: -6.5,
    transform: "matrix(0.894427 0.447214 0.447214 -0.894427 6 0)",
    stroke: "white",
    strokeWidth: 13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalArrow);
export default __webpack_public_path__ + "static/media/verticalArrow.3fb92c5c28bcc751c075585c589f9147.svg";
export { ForwardRef as ReactComponent };